module.exports = __webpack_public_path__ + "logo_87-5f383eb597638b6b05c52e9914c5133b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_87.png
// module id = 1145
// module chunks = 0 1